export const getInstrumentNonOperationalModalConfig = () => {
  const key = 'dontShowInstrumentNonOperationalModal';
  const value = window.localStorage.getItem(key);
  let config = {};

  if (value) {
    config = JSON.parse(value);
  }

  return config;
};

export const setInstrumentNonOperationalModalConfig = (val) => {
  const key = 'dontShowInstrumentNonOperationalModal';
  const prevConfig = getInstrumentNonOperationalModalConfig();
  const newConfig = {...prevConfig, ...val};

  window.localStorage.setItem(key, JSON.stringify(newConfig));
};

export const removeInstrumentNonOperationalModalConfig = () => {
  const key = 'dontShowInstrumentNonOperationalModal';
  window.localStorage.removeItem(key);
};
